import { Component, input, OnDestroy, OnInit, output, Self, signal } from '@angular/core';
import { ControlValueAccessor, FormControl, FormControlStatus, NgControl } from '@angular/forms';

import { faCircleExclamation, faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { distinctUntilChanged, ReplaySubject, Subscription } from 'rxjs';

@Component({
  selector: 'eiq-input-verify',
  templateUrl: 'input-verify.component.html',
  styleUrls: ['input-verify.component.scss']
})
export class InputVerifyComponent implements OnInit, OnDestroy, ControlValueAccessor {
  hint = input<string>();
  label = input<string>();
  maxLength = input<number>();
  placeholder = input<string>();
  prefix = input<string>();
  testId = input<string>();
  type = input<'text' | 'number' | 'email' | 'tel' | 'password'>('text');

  keyupEnter = output<void>();
  blur = output<void>();

  loading$ = signal<boolean>(false);
  verified$ = signal<FormControlStatus>(null);

  faCircleCheck = faCircleCheck;
  faCircleExclamation = faCircleExclamation;

  onChange: (value: string) => void;
  onTouched: () => void;

  control: FormControl;
  currentValue: string;

  private input$ = new ReplaySubject(1);
  private subscriptions: Subscription[] = [];

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.control = this.ngControl.control as FormControl;

    this.subscriptions.push(
      this.input$.subscribe((i: string) => {
        this.onTouched();
        this.onChange(i);
      })
    );

    this.subscriptions.push(
      this.control.statusChanges.pipe(distinctUntilChanged()).subscribe((status: FormControlStatus) => {
        if (status === 'PENDING' && !this.loading$()) {
          this.loading$.set(true);
        } else if (status !== 'PENDING') {
          this.loading$.set(false);
          this.verified$.set(status);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(i: string): void {
    this.currentValue = i ?? '';
  }

  setValue($event: any): void {
    this.currentValue = $event.target.value;
    this.input$.next($event.target.value);
  }

  clearValue(): void {
    this.currentValue = '';
    this.input$.next('');
  }

  setDisabledState?(_isDisabled: boolean): void {
    // Implement if needed
  }
}
